import { render, staticRenderFns } from "./BriefDialog.vue?vue&type=template&id=98f42d4e&scoped=true&"
import script from "./BriefDialog.vue?vue&type=script&lang=js&"
export * from "./BriefDialog.vue?vue&type=script&lang=js&"
import style0 from "./BriefDialog.vue?vue&type=style&index=0&id=98f42d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f42d4e",
  null
  
)

/* custom blocks */
import block0 from "./BriefDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports